import React, { useState, useEffect } from "react";
import { Box, Text, VStack, Flex, Spinner, Input } from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getProducts = async () => {
      try {
        setLoading(true);
        const response = await api.get("/admin/products");
        setProducts(response.data.data);
      } catch {
        toast.error(
          "Não foi possível buscar os seus produtos, entre em contato com o suporte.",
        );
      } finally {
        setLoading(false);
      }
    };

    getProducts();
  }, []);

  return (
    <>
      <HeaderTools
        title="Produtos"
        showSearch
        onClickSearch={() => setShowSearch((prev) => !prev)}
      />

      {loading && (
        <Flex justifyContent="center" mt="20px">
          <Spinner />
        </Flex>
      )}

      {!loading && (
        <VStack spacing={4} mt={4} align="stretch" p={4}>
          {showSearch && (
            <Input
              placeholder="Pesquisar..."
              backgroundColor="white"
              padding="15px"
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
          {products
            .filter(
              (product) =>
                product.prod_descricao
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                product.prod_referencia
                  ?.toLowerCase()
                  .includes(search.toLowerCase()),
            )
            .map((product) => (
              <Box
                key={product.id}
                p={4}
                bg="white"
                borderRadius="md"
                boxShadow="sm"
                cursor="pointer"
                _hover={{ bg: "gray.50" }}
                onClick={() =>
                  navigate(`/painel/produtos/${product.prod_id}/imagens`)
                }
              >
                <Text fontWeight="bold">{product.prod_descricao}</Text>
                <Text fontSize="12px" color="gray.500">
                  {product.categoria}
                </Text>
                <Text fontSize="sm" color="gray.500">
                  #{product.prod_referencia}
                </Text>
              </Box>
            ))}
        </VStack>
      )}
    </>
  );
}
